import { RootState } from 'models/store';

// ==============================|| DEVICE SELECTORS ||============================== //

export const selectDeviceList = (state: RootState) =>
  state.eai.device.deviceList.deviceList;

export const selectDeviceListPage = (state: RootState) =>
  state.eai.device.deviceList.page;

export const selectDeviceDetailList = (state: RootState) =>
  state.eai.device.deviceDetail;

export const selectDeviceCharacteristicGroupDetailList = (state: RootState) =>
  state.eai.device.deviceCharacteristicGroupDetail;

export const selectDevicesForPlanning = (state: RootState) =>
  state.eai.device.deviceList.devicesForPlanning;

export const selectDevicesListLengthForPlanning = (state: RootState) =>
  state.eai.device.deviceList.devicesForPlanning.length;
